import { render, staticRenderFns } from "./News.vue?vue&type=template&id=a20b7fee&scoped=true&"
var script = {}
import style0 from "./News.vue?vue&type=style&index=0&id=a20b7fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20b7fee",
  null
  
)

export default component.exports